import { render, staticRenderFns } from "./FooterAdmin.vue?vue&type=template&id=765a0022&"
import script from "./FooterAdmin.vue?vue&type=script&lang=js&"
export * from "./FooterAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports